import { render, staticRenderFns } from "./CarouselSplitModule.vue?vue&type=template&id=65f25444&"
import script from "./CarouselSplitModule.ts?vue&type=script&lang=ts&"
export * from "./CarouselSplitModule.ts?vue&type=script&lang=ts&"
import style0 from "./CarouselSplitModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports